import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-setting',
  templateUrl: './doc-setting.component.html',
  styleUrls: ['./doc-setting.component.css']
})
export class DocSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
